import FormerSubscriber from 'components/molecules/former_subscriber';
import RegisterBeginner from 'components/molecules/RegisterBeginner';
import PlansList from 'pages/PlansList';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { ApplicationState } from 'store';
import { PanelState } from 'store/modules/panel_store/types';
import {
  SimulateRegister,
  SimulateWasSubscriber,
} from 'store/modules/proportional_sale_simulation_store/actions';

const RegistrationFlow = () => {
  const dispatch = useDispatch();

  const { panel } = useSelector<ApplicationState, PanelState>((state) => state.session.panel);

  useEffect(() => {
    panel?.registration_type_validation === 1 && dispatch(SimulateRegister());

    panel?.registration_type_validation === 3 && dispatch(SimulateWasSubscriber());
  }, []);

  if (panel?.registration_type_validation === 0 || panel?.registration_type_validation === 2) {
    return <Redirect to="/painel" />;
  }

  return (
    <div>
      {panel?.registration_type_validation === 1 && <RegisterBeginner />}

      {panel?.registration_type_validation === 5 && <PlansList />}

      {panel?.registration_type_validation === 3 && <FormerSubscriber />}
    </div>
  );
};

export default RegistrationFlow;
